"use client";
import {
  useFormStore
} from "../__chunks/CYMKTFW2.js";
import {
  FormContextProvider
} from "../__chunks/F53GGRQB.js";
import "../__chunks/C3IKGW5T.js";
import "../__chunks/VDHZ5F7K.js";
import "../__chunks/LMDWO4NN.js";
import "../__chunks/YV4JVR4I.js";
import "../__chunks/ABQUS43J.js";
import "../__chunks/SK3NAZA3.js";
import "../__chunks/3YLGPPWQ.js";

// src/form/form-provider.tsx
import { jsx } from "react/jsx-runtime";
function FormProvider(props = {}) {
  const store = useFormStore(props);
  return /* @__PURE__ */ jsx(FormContextProvider, { value: store, children: props.children });
}
export {
  FormProvider
};
